import { type Address } from "viem";
import { type UserStatusType } from "../secure-chat";

type LinkTypes = "twitter" | "facebook" | "discord" | "telegram" | "website";

interface ImageType {
  id: string;
  url: string;
  avatar_url?: string;
  key: string;
  attachment_type: string;
  metadata: string;
  dimension: string;
}

interface CoverType {
  id: string;
  url: string;
  key: string;
  attachment_type: string;
  metadata: string;
  dimension: string;
}

interface RelationType {
  is_follower: boolean;
  is_blocking?: boolean;
  is_blocked?: boolean;
  followings?: number[];
  followers?: number[];
  pinned_followings?: any;
}
interface NickNameType {
  created_at: string;
  creator_id: string;
  friend_id: string;
  id: string;
  name: string;
  updated_at: string;
}

interface NFTImageType {
  id: string;
  animation_url?: string;
  avatar_crop_url?: string;
  avatar_url: string;
  balance: number;
  chain_id: string | number;
  contract_address: string;
  data_type?: any;
  desc?: string;
  external_url?: string;
  name: string;
  nft_type: string;
  owner_address: string;
  title: string;
  token_id: string;
  uri: string;
}

interface DeviceType {
  id: string;
  app_name?: string;
  app_version?: string;
  device_token: string;
  platform?: string;
  user_id: string;
}

export enum UserType {
  SYSTEM = "system",
  CHATBOT = "chatbot",
}

interface UserInfoType {
  id: string;
  display_name: string;
  wallet_address: Address;
  bio: string;
  description?: string;
  status: UserStatusType;
  user_type?: UserType;
  public_key?: string;
  avatar_id?: string;
  cover_id?: string;
  social_networks: Record<LinkTypes, string>;
  nft_avatar?: NFTImageType;
  avatar?: ImageType;
  cover?: CoverType;
  percentile_score?: number;
  relation?: RelationType;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string;
  follower_count?: number;
  following_count?: number;
  token?: string;
  nickname: NickNameType | null;
  referral_code?: string | null;
  referrals_count?: number | null;
  has_invited?: boolean;
  devices?: DeviceType[];
  disabled_notification: boolean;
  disabled_searching: boolean;
}

export type {
  LinkTypes,
  UserInfoType,
  ImageType,
  NFTImageType,
  CoverType,
  NickNameType,
  DeviceType,
};
